import type { ReactNode } from 'react'
import { JudgmentProvider } from '@biznomi/ui-react'
import { useOrg } from './useOrg'

/**
 * 조직 설정 → AttendanceTime 컨텍스트로 넘기는 유일한 어댑터.
 *
 * ⚠️ 이 파일은 judgmentMode 를 다루도록 허용된 곳이다. 하는 일은 값을 실어
 *    나르는 것뿐이고, 판정 분기는 하지 않는다. 화면에서 이 값을 다시 읽지 말 것.
 *    가드레일 = scripts/guardrails/check-judgment-mode.sh
 */
export function JudgmentBoundary({ children }: { children: ReactNode }) {
  const { data: org } = useOrg()

  return (
    <JudgmentProvider
      value={{
        mode: org?.judgmentMode ?? 'FACTUAL',
        workStartTime: org?.workStartTime,
        workEndTime: org?.workEndTime,
        // 조직이 정한 값을 그대로 넘긴다. 0 을 박아두면 유예 설정이 무효가 된다
        graceMinutes: org?.lateGraceMinutes ?? 0,
        earlyLeaveMinutes: org?.earlyLeaveMinutes ?? 0,
        // 기준 시각을 화면에 보일지 (§4 B #7)
        showWorkHours: org?.uiConfig?.showWorkHours !== false,
      }}
    >
      {children}
    </JudgmentProvider>
  )
}
